
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitokonkandarshan() {



    const cardData =
    {
        keyword: 'Mumbai to Konkan Darshan Cab',
        heading: 'S9 Travels: Mumbai to Konkan Darshan Cab',
        headingDescription: 'S9 Travels offers Mumbai to Konkan Darshan Cab Service, ensuring a comfortable, reliable, and hassle-free journey through the scenic Konkan region. Whether you are exploring beaches, temples, forts, or lush greenery, our Innova cabs provide a smooth and enjoyable ride. With spacious interiors, luxury features, and experienced drivers, we guarantee a safe and stress-free travel experience. Enjoy on-time pickups, affordable pricing, and 24/7 service. Book your Mumbai to Konkan Darshan cab with S9 Travels for an unforgettable trip!',


        top: 'Top Places to Visit in Konkan with S9 Travels',

"topPlaces": [
    {
      "title": "Ganpatipule Beach",
      "description": "A pristine beach with golden sands and clear waters, Ganpatipule Beach is famous for its tranquil beauty and the revered Ganpati Temple nearby."
    },
    {
      "title": "Tarkarli Beach",
      "description": "A stunning beach known for its crystal-clear waters, Tarkarli Beach is a paradise for water sports enthusiasts, offering scuba diving and snorkeling."
    },
    {
      "title": "Sindhudurg Fort",
      "description": "A historic sea fort built by Chhatrapati Shivaji Maharaj, Sindhudurg Fort stands as a testament to Maratha naval strength and offers breathtaking sea views."
    },
    {
      "title": "Murud-Janjira Fort",
      "description": "An invincible island fortress surrounded by the Arabian Sea, Murud-Janjira Fort is known for its strong architecture and historical significance."
    },
    {
      "title": "Alibaug Beach",
      "description": "A popular weekend getaway from Mumbai, Alibaug Beach is known for its black sand shores, water sports, and stunning sunset views."
    },
    {
      "title": "Diveagar Beach",
      "description": "A peaceful and less crowded beach, Diveagar is known for its golden sands, coconut groves, and the famous Suvarna Ganesh Temple."
    },
    {
      "title": "Harihareshwar",
      "description": "A serene coastal town, Harihareshwar is famous for its beaches, temples, and the scenic ‘pradakshina’ route around the Shiva temple."
    },
    {
      "title": "Ratnagiri",
      "description": "Known for its Alphonso mangoes, Ratnagiri also boasts beautiful beaches, historical forts, and the birthplace of freedom fighter Lokmanya Tilak."
    },
    {
      "title": "Dapoli",
      "description": "A hill station by the sea, Dapoli is known for its beaches, dolphin spotting, hot water springs, and ancient temples."
    },
    {
      "title": "Velas Beach",
      "description": "Famous for its turtle conservation project, Velas Beach is a unique eco-tourism destination where visitors can witness the hatching of Olive Ridley turtles."
    }
],

"services": [
    {
      "name": "Mumbai to Konkan Darshan Cab",
      "description": "S9 Travels offers a reliable and comfortable cab service for your Konkan Darshan trip. Enjoy the scenic beauty of the Konkan coastline with a safe and smooth ride from Mumbai."
    },
    {
      "name": "Book Konkan Darshan Taxi from Mumbai",
      "description": "Booking a taxi for your Konkan Darshan trip from Mumbai is easy with S9 Travels. Choose from one-way or round-trip options and enjoy a comfortable journey to explore the beautiful Konkan region."
    },
    {
      "name": "Mumbai to Konkan Sightseeing by Cab",
      "description": "Explore the picturesque Konkan region with S9 Travels’ sightseeing taxi service. Visit beautiful beaches, historic forts, and serene landscapes with a professional driver."
    },
    {
      "name": "Affordable Mumbai to Konkan Darshan Cab",
      "description": "S9 Travels offers affordable and budget-friendly cab services for your Konkan Darshan trip. Enjoy comfort, safety, and great prices for a memorable journey to the Konkan region."
    },
    {
      "name": "Private Taxi for Konkan Darshan from Mumbai",
      "description": "For a more personalized experience, book a private taxi for your Konkan Darshan trip with S9 Travels. Enjoy the freedom and flexibility of exploring the Konkan region in comfort and style."
    },
    {
      "name": "Mumbai to Konkan Trip by Private Cab",
      "description": "Travel from Mumbai to the Konkan region with ease and comfort. S9 Travels offers private cab services to ensure a relaxed and enjoyable ride for your entire trip."
    },
    {
      "name": "Konkan Darshan Group Tours",
      "description": "S9 Travels provides group taxi services for Konkan Darshan tours. Whether you're with family, friends, or colleagues, we ensure a comfortable and safe group travel experience to Konkan."
    },
    {
      "name": "Luxury Taxi for Konkan Darshan",
      "description": "Travel in style and comfort with S9 Travels’ luxury taxi services for Konkan Darshan. Our premium vehicles and professional chauffeurs ensure a luxurious experience throughout your trip."
    },
    {
      "name": "Konkan Sightseeing Tour from Mumbai",
      "description": "Take a sightseeing tour of Konkan with S9 Travels. Our experienced drivers will guide you to popular Konkan attractions like beaches, forts, and hill stations for an unforgettable experience."
    },
    {
      "name": "Comfortable Taxi Ride from Mumbai to Konkan",
      "description": "S9 Travels offers comfortable taxi rides for your trip from Mumbai to Konkan. Enjoy a smooth and pleasant journey with our well-maintained vehicles and experienced drivers."
    },
    {
      "name": "Konkan Beach Tour by Cab",
      "description": "Explore the pristine beaches of Konkan with S9 Travels’ beach tour by cab. Visit popular beaches like Alibaug, Kashid, and Ganpatipule in comfort and style with our taxi services."
    }
],

"tableData": [
  ["Mumbai to Konkan Darshan Cab", "Book Konkan Darshan Taxi from Mumbai"],
  ["Mumbai to Konkan Sightseeing by Cab", "Affordable Mumbai to Konkan Darshan Cab"],
  ["Private Taxi for Konkan Darshan from Mumbai", "Mumbai to Konkan Trip by Private Cab"],
  ["Konkan Darshan Group Tours", "Luxury Taxi for Konkan Darshan"],
  ["Konkan Sightseeing Tour from Mumbai", "Comfortable Taxi Ride from Mumbai to Konkan"],
  ["Konkan Beach Tour by Cab", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Explore Konkan’s Beauty in Comfort",
    "WhyChoosedescription": "S9 Travels offers a comfortable Mumbai to Konkan Darshan cab service, perfect for exploring the stunning Konkan coastline. Our well-maintained vehicles, including the Toyota Innova, ensure a smooth and comfortable journey while you take in the breathtaking views of beaches, hills, and villages along the Konkan route."
  },
  {
    "WhyChooseheading": "Timely and Reliable Service",
    "WhyChoosedescription": "With S9 Travels, you can count on timely and reliable service for your Mumbai to Konkan Darshan trip. Our professional drivers ensure prompt pick-ups and drop-offs, so you can fully enjoy your journey without worrying about delays or missing key sightseeing spots."
  },
  {
    "WhyChooseheading": "Experienced Drivers for a Smooth Journey",
    "WhyChoosedescription": "Our experienced drivers are familiar with the scenic yet winding roads from Mumbai to Konkan. With knowledge of the best routes and traffic patterns, they ensure a safe, efficient, and enjoyable trip, making your Konkan Darshan experience as smooth as possible."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable pricing for your Mumbai to Konkan Darshan cab service. We believe in complete transparency, with no hidden charges. You’ll receive a clear cost breakdown during the booking process, allowing you to plan your trip within your budget."
  },
  {
    "WhyChooseheading": "Safety and Comfort Along the Journey",
    "WhyChoosedescription": "Safety is our top priority. Our cabs are equipped with modern safety features, including GPS tracking, airbags, and seat belts. Whether you’re traveling alone, with family, or in a group, you can relax knowing you're in safe hands throughout your Konkan Darshan tour."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Travel",
    "WhyChoosedescription": "S9 Travels operates 24/7, so you can book your Mumbai to Konkan Darshan cab at any time that suits your travel schedule. Whether you want to leave early in the morning or travel later in the day, we are always available to provide the perfect solution for your trip."
  },
  {
    "WhyChooseheading": "Customizable Konkan Darshan Itinerary",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you want to visit specific attractions or customize your stops along the way, we offer flexible and customizable travel packages for your Mumbai to Konkan Darshan journey, ensuring a personalized and memorable experience."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Mumbai to Konkan Darshan cab with S9 Travels is easy and hassle-free. You can conveniently book online via our website or app, or reach out to our customer service team for assistance. We aim to make your booking experience quick, easy, and stress-free."
  }
]









    }


    const faqData = [
        [
          {
            question: 'How can I book a cab for Mumbai to Konkan Darshan with S9 Travels?',
            answer: 'Booking a cab for Mumbai to Konkan Darshan is simple! You can book your ride through our website or app, or contact our customer service team for personalized assistance in planning your scenic Konkan Darshan trip.',
          },
          {
            question: 'What types of vehicles are available for Mumbai to Konkan Darshan travel?',
            answer: 'We offer a variety of vehicles for your Mumbai to Konkan Darshan journey, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose a vehicle that best suits your preferences for a comfortable, scenic ride along the beautiful Konkan coastline.',
          },
          {
            question: 'How long does the journey from Mumbai to Konkan Darshan take?',
            answer: 'The journey from Mumbai to Konkan Darshan typically takes 6 to 8 hours, depending on the destinations you plan to visit in Konkan and road conditions. Our experienced drivers ensure a smooth and pleasant journey along the coastal routes.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel like Mumbai to Konkan Darshan?',
            answer: 'Yes, all our drivers are highly experienced in long-distance travel and are well-versed with the scenic routes and popular stops along the Konkan coast. They prioritize safety and comfort, ensuring a memorable trip.',
          },
          {
            question: 'Can I book a round trip for Mumbai to Konkan Darshan?',
            answer: 'Yes, we offer round-trip bookings for your Mumbai to Konkan Darshan journey. You can plan your return trip based on your schedule, and we will ensure a smooth and timely return from the Konkan region to Mumbai.',
          },
          {
            question: 'Is there a fixed fare for Mumbai to Konkan Darshan cab service?',
            answer: 'The fare for Mumbai to Konkan Darshan travel depends on the type of vehicle, the specific destinations included in your trip, and the trip duration. Please contact us for a customized quote and transparent pricing.',
          },
          {
            question: 'Do you provide pick-up services from Mumbai airport or hotels for Konkan Darshan trips?',
            answer: 'Yes, we provide pick-up services from Mumbai airport or hotels for your Konkan Darshan trip. Our driver will ensure a smooth and comfortable transfer to your starting point and ensure a hassle-free journey to the Konkan region.',
          },
          {
            question: 'Can I request additional stops on the way to Konkan Darshan?',
            answer: 'Yes, we can accommodate additional stops for sightseeing, meals, or any other breaks during your journey. Whether it’s a visit to popular Konkan destinations like Alibaug, Ganpatipule, or Tarkarli, we can customize your itinerary based on your preferences.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during the Mumbai to Konkan Darshan trip?',
            answer: 'Any extra charges for waiting time or detours will be communicated to you upfront during the booking process, ensuring full transparency. We strive to provide a seamless and hassle-free experience during your trip.',
          },
          {
            question: 'Why should I choose S9 Travels for my Mumbai to Konkan Darshan cab service?',
            answer: 'S9 Travels offers reliable, comfortable, and safe cab services for your Mumbai to Konkan Darshan journey. With well-maintained vehicles, professional drivers, and exceptional customer service, we ensure a scenic and enjoyable trip along the beautiful Konkan coastline.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Vikram Patel',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked a Mumbai to Konkan Darshan trip with S9 Travels, and it was an unforgettable experience. The driver was well-versed with the Konkan routes and took us to beautiful destinations. The vehicle was comfortable, and the trip was very smooth. Highly recommend S9 Travels for any Konkan trips!”',
        },
        {
          name: 'Mrs. Nisha Sharma',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our family took a Mumbai to Konkan Darshan trip with S9 Travels, and it was fantastic. The driver was courteous and knowledgeable about the places to visit in Konkan. The car was spacious and well-maintained. We had an amazing time exploring the coastal beauty of Konkan. Highly recommend their services!”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
     
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Mumbai to Konkan Darshan Cab",
        "description": "Book affordable and reliable Mumbai to Konkan Darshan cab services for sightseeing, beach tours, and group travel. S9 Travels offers private taxi rides for a comfortable and scenic journey from Mumbai to Konkan, including luxury taxis and Konkan Darshan tours.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
      
      
      


    return (
        <div>
        
        <Helmet>
        <title>Mumbai to Konkan Darshan Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Mumbai to Konkan Darshan taxi services, including sightseeing tours, private cabs, luxury travel, and group tours. Affordable and comfortable transport for your Konkan beach and sightseeing tour from Mumbai with S9 Travels." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
      

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/56.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitokonkandarshan;